import React from 'react';
import {NavLink} from 'react-router-dom';
import {mainPath} from '../../../../routes/paths';
import Count from '../../../../features/Components/Count';
import {useSelector} from "react-redux";

const SideBgProjectItem = ({address, hasNotification, id, count}) => {
    const profileMe = useSelector((state) => state.profile.profileMe);

    const isFinancier = profileMe.role === 'financier';
    return (
    <NavLink to={mainPath.project.replace(':id', id)} className={'side-bg__item'}>
      {!isFinancier && count && count > 0 ? <Count className={'side-bg__count'} count={count} color={'blue'} size={'xxs'} /> : null}
      <span>{address}</span>
      <span>
        {!isFinancier && hasNotification && (
          <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path
              d='M14.1296 16.4446C13.8713 17.7107 12.7491 18.6668 11.408 18.6668C10.0668 18.6668 8.94406 17.7107 8.68629 16.4446H14.1296ZM16.1302 9.22239C17.2024 9.22239 18.0746 8.35016 18.0746 7.27794C18.0746 6.20572 17.2024 5.3335 16.1302 5.3335C15.058 5.3335 14.1857 6.20572 14.1857 7.27794C14.1857 8.35016 15.058 9.22239 16.1302 9.22239ZM16.2635 10.3268C16.2191 10.3285 16.1752 10.3335 16.1302 10.3335C14.4452 10.3335 13.0746 8.96294 13.0746 7.27794C13.0746 6.77572 13.1985 6.30239 13.4146 5.88405C12.758 5.53127 12.0113 5.3335 11.228 5.3335C9.06073 5.3335 7.18462 6.8385 6.71462 8.9535L5.40906 13.1741C5.0774 14.2463 5.87906 15.3329 7.00128 15.3329H15.6991C16.8546 15.3329 17.6596 14.1857 17.2663 13.0991L16.263 10.3257L16.2635 10.3268Z'
              fill='#FFB508'
            />
          </svg>
        )}
      </span>
    </NavLink>
  );
};

export default SideBgProjectItem;
